export type AppointmentType = 'doctor' | 'checkup' | 'ultrasound' | 'course' | 'personal';
export type ReminderType = 'none' | '1_day' | '1_week';

export type RecurrencePattern = 'weekly' | 'biweekly' | 'monthly';
export type RecurrenceEndMode = 'until' | 'count';
export type SeriesScope = 'single' | 'following' | 'all';

export interface RecurrenceConfig {
  pattern: RecurrencePattern;
  endMode: RecurrenceEndMode;
  endDate?: string; // YYYY-MM-DD; wenn endMode === 'until'
  count?: number; // wenn endMode === 'count'
}

export const RECURRENCE_LIMITS: Record<RecurrencePattern, number> = {
  weekly: 52,
  biweekly: 26,
  monthly: 12,
};

export interface Appointment {
  id: string;
  pregnancy_id: string;
  created_by: string;
  title: string;
  description?: string | null;
  appointment_date: string; // YYYY-MM-DD
  appointment_time?: string | null; // HH:MM
  is_all_day: boolean;
  appointment_type: AppointmentType;
  reminder: ReminderType;
  is_predefined: boolean;
  ssw_week?: number | null;
  recurrence_group_id: string | null;
  recurrence_pattern: RecurrencePattern | null;
  created_at: string;
  updated_at: string;
}

export interface AppointmentInput {
  title: string;
  description?: string;
  appointment_date: string;
  appointment_time?: string;
  is_all_day: boolean;
  appointment_type: AppointmentType;
  reminder: ReminderType;
  recurrence?: RecurrenceConfig;
}

export interface PredefinedCheckup {
  ssw_week: number;
  title: string;
  description: string;
  appointment_type: AppointmentType;
}

export const APPOINTMENT_TYPE_LABELS: Record<AppointmentType, string> = {
  doctor: 'Arzttermin',
  checkup: 'Vorsorge',
  ultrasound: 'Ultraschall',
  course: 'Kurs',
  personal: 'Persönlich',
};

export const APPOINTMENT_TYPE_COLORS: Record<AppointmentType, string> = {
  doctor: 'bg-blue-100 text-blue-700',
  checkup: 'bg-green-100 text-green-700',
  ultrasound: 'bg-purple-100 text-purple-700',
  course: 'bg-orange-100 text-orange-700',
  personal: 'bg-gray-100 text-gray-700',
};

export const REMINDER_LABELS: Record<ReminderType, string> = {
  none: 'Keine Erinnerung',
  '1_day': '1 Tag vorher',
  '1_week': '1 Woche vorher',
};
